import { render } from "./product-price.vue?vue&type=template&id=7191dac0&lang=pug"
import script from "./product-price.vue?vue&type=script&lang=js"
export * from "./product-price.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__